import type { FaireProductEntity } from "../../entity_types/product";

export const p_rdw4w8y243: FaireProductEntity = {
  token: "p_rdw4w8y243",
  type: "product",
  name: "Ships of the Great Lakes Playing Cards",
  brandName: "AdventureKEEN",
  imageUrl:
    "https://cdn.faire.com/fastly/a5cabf7f3f14ffee03036625027d0b2dde181f4d48390267b6d36b6fc711444e.jpeg",
  priceDollars: 4.48,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7ce6445b1eafe52cb4c04eb0ed7795237c303d3ac019b8434b0d98325318f9a8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
